export const HEARTBEAT_SET = 'HEARTBEAT_SET';